import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnSuccess,
    markSkipOnCompleteIfOnErrorIsSet,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import loadOrderByOrderNumber from "@insite/client-framework/Store/Data/Orders/Handlers/LoadOrderByOrderNumber";
import { getOrderState } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import { OrderModel } from "@insite/client-framework/Types/ApiModels";
import { updateOrder, UpdateOrderApiParameter } from "@MasterBluePrint/Services/OrderCancleService";

type CancleOrderRequestParameter = {
    onError?: (errorMessage: string) => void;
} & HasOnSuccess<OrderModel>;
type HandlerType = ApiHandlerDiscreteParameter<
    CancleOrderRequestParameter,
    UpdateOrderApiParameter,
    ServiceResult<OrderModel>
>;

const CANCEL_STATUS = "CancellationRequested";

export const DispatchBeginCancelOrder: HandlerType = props => {
    props.dispatch({
        type: "Pages/OrderDetails/BeginCancelOrder",
    });
};

export const PopulateApiParameter: HandlerType = props => {
    const state = props.getState();
    const order = getOrderState(state, state.pages.orderDetails.orderNumber);
    if (!order.value) {
        throw new Error("CancelOrder was called but there was no order");
    }

    props.apiParameter = {
        order: {
            ...order.value,
            status: CANCEL_STATUS,
        },
    };
};

export const SendDataToApi: HandlerType = async props => {
    try {
        props.apiResult = await updateOrder(props.apiParameter);
    } catch (error) {
        throw new Error(error.errorJson.message);
    }
};
export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        markSkipOnCompleteIfOnSuccessIsSet(props);
        props.parameter.onSuccess?.(props.apiResult.result);
    }
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult.successful) {
        markSkipOnCompleteIfOnErrorIsSet(props);
        props.parameter.onError?.(props.apiResult.errorMessage);
    }
};
export const DispatchCompleteCancelOrder: HandlerType = props => {
    props.dispatch({
        type: "Pages/OrderDetails/CompleteCancelOrder",
    });
    if (props.apiResult.successful) {
        props.dispatch(
            loadOrderByOrderNumber({
                orderNumber: props.apiResult.result.webOrderNumber || props.apiResult.result.erpOrderNumber,
                expand: props.apiResult.result.vmiLocationId
                    ? ["orderLines", "shipments", "vmidetails"]
                    : ["orderLines", "shipments"],
            }),
        );
    }
};

export const chain = [
    DispatchBeginCancelOrder,
    PopulateApiParameter,
    SendDataToApi,
    ExecuteOnSuccessCallback,
    ExecuteOnErrorCallback,
    DispatchCompleteCancelOrder,
];

const cancelOrder = createHandlerChainRunner(chain, "CancelOrder");
export default cancelOrder;
